import { Outlet } from 'react-router-dom'

// Auth pages now own their full-screen layout (SplitAuthLayout), so this
// wrapper is a pass-through. Kept as a component so existing router / guard
// references (`<AuthLayout>...</AuthLayout>`) keep working during the redesign.
export default function AuthLayout({ children }) {

    return children ? children : <Outlet />
}
